import { VStack } from "@gluestack-ui/themed";
import { MenuActionsList } from "@repo/core/components/layout/MenuActionsList";
import Scaffolds from "@repo/core/components/layout/Scaffolds";
import { StatusBarVariantEnum } from "@repo/core/components/layout/StatusBar/types";
import { NewTransactionPaymentOptionsController } from "@repo/core/screens/NewTransaction/NewTransactionPaymentOptions/controller";

const NewTransactionPaymentOptions = () => {
  const { isMobile, menuActionItems, handleBack, title } =
    NewTransactionPaymentOptionsController();

  return (
    <Scaffolds.Root
      showHeader={false}
      statusBarVariant={StatusBarVariantEnum.STORE_SELECT}
    >
      <Scaffolds.StoreSelect title={title} onBackPress={handleBack}>
        <VStack
          space="lg"
          alignItems={isMobile ? "flex-start" : "center"}
          pt="$3"
          px={isMobile ? "$4" : "$6"}
          w="$full"
        >
          <MenuActionsList
            title="Tipo de parcelamento"
            menuItems={menuActionItems}
          />
        </VStack>
      </Scaffolds.StoreSelect>
    </Scaffolds.Root>
  );
};

export default NewTransactionPaymentOptions;
